import { AxiosResponse } from "axios";
import { get, post, put, routes } from "api";
import { IClientConfig } from "api/types";
import { ILegalAcknowledgementData } from "models/legalAcknowledgement.models";
import {
  ICreateUserRequestData,
  IGetUserProjectRolesRequestParams,
  IGetUsersListRequestParams,
  IUserRole,
} from "models/users.models";

const user = {
  agreeToAcknowledgement(
    id: string,
    firstName: string,
    lastName: string,
    isMockApiOn?: boolean,
  ): Promise<AxiosResponse<ILegalAcknowledgementData[]>> {
    return put<ILegalAcknowledgementData[]>(
      routes.identity.user.acknowledgementById(id),
      {
        data: {
          accepted: true,
          firstName,
          lastName,
        },
        isMockApiOn,
      },
    );
  },

  getUser(id: string, config?: IClientConfig): Promise<AxiosResponse> {
    return get(routes.identity.user.byId(id), config);
  },

  getCurrentUser(): Promise<AxiosResponse> {
    return get(routes.identity.user.current());
  },

  getUsersList(
    params: IGetUsersListRequestParams = {},
    isMockApiOn?: boolean,
  ): Promise<AxiosResponse> {
    return get(routes.identity.user.all(), {
      params,
      isMockApiOn,
    });
  },

  getTimeZones: (isMockApiOn?: boolean): Promise<AxiosResponse> => {
    return get(routes.identity.user.timezones(), { isMockApiOn });
  },

  getCurrentUserRoles: (isMockApiOn?: boolean): Promise<AxiosResponse> => {
    return get(routes.identity.user.getCurrentUserRoles(), {
      isMockApiOn,
    });
  },

  getUserProjectRoles: (
    params?: IGetUserProjectRolesRequestParams,
  ): Promise<AxiosResponse<IUserRole[]>> => {
    return get(routes.identity.user.getUserProjectRoles(), { params });
  },

  getUsersTemplate: (): Promise<AxiosResponse> => {
    return get(routes.identity.user.getUsersTemplate(), {
      responseType: "blob",
      headers: {
        Accept: "application/pdf",
      },
    });
  },

  uploadUserTemplate: (data: FormData): Promise<AxiosResponse> => {
    return put(routes.identity.user.uploadUserTemplate(), {
      data,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  createUser: (data: ICreateUserRequestData): Promise<AxiosResponse> => {
    return post(routes.identity.user.all(), { data });
  },

  activateUser: (userId: string): Promise<AxiosResponse> => {
    return post(routes.identity.user.activationRequestById(userId));
  },

  deactivateUser: (userId: string): Promise<AxiosResponse> => {
    return post(routes.identity.user.deactivationRequestById(userId));
  },
};

export default user;
